<!-- DESKTOP - MENUS -->
<ion-row
  class="ion-hide-lg-down footer-row-top ion-align-items-start ion-padding-horizontal">
  <ion-col *ngFor="let item of menus">
    <ion-text color="light">
      <h3>{{ item.title }}</h3>
    </ion-text>
    <ion-text *ngFor="let child of item.children">
      <a
        hrefToRouterLink
        [href]="linkToPage(child)"
        [attr.target]="child.newWindow ? '_blank' : '_self'"
        >{{ child.title }}</a
      >
    </ion-text>
  </ion-col>
</ion-row>

<!-- DESKTOP - LOGO STRIP -->
<ion-row class="ion-hide-lg-down logo ion-align-items-center logo-strip">
  <ion-col class="ion-no-padding">
    <div class="divider"></div>
  </ion-col>
  <ion-col size="auto" class="ion-no-padding ion-padding-horizontal">
    <ng-container
      *ngIf="
        environment.environment_name === 'canalwalk' ||
          environment.environment_name === 'glen';
        else singleLogo
      ">
      <a href="https://www.hyprop.co.za/" target="_blank" class="logo-hyprop">
        <img
          src="/assets/logo-hyprop.png"
          srcset="/assets/logo-hyprop@2x.png 2x"
          alt="Hyprop"
          height="65" />
      </a>
      <img
        src="/assets/logo-ellerines.png"
        srcset="/assets/logo-ellerines@2x.png 2x"
        alt="Hyprop"
        class="logo-ellerines"
        height="64" />
    </ng-container>
    <ng-template #singleLogo>
      <a href="https://www.hyprop.co.za/" target="_blank">
        <svg
          width="52"
          height="49"
          viewBox="0 0 52 49"
          fill="none"
          xmlns="http://www.w3.org/2000/svg">
          <path
            d="M47.0602 12.1279L11.8572 0.402452C10.7145 0.0219435 9.49967 -0.0907874 8.3065 0.07297C7.11333 0.236727 5.97377 0.672589 4.97587 1.34688C3.97797 2.02117 3.14844 2.91584 2.55136 3.96178C1.95429 5.00771 1.60565 6.1769 1.53238 7.37903L0.0116766 32.8309C-0.066233 34.0545 0.247247 35.2711 0.906743 36.3047C1.56624 37.3384 2.53754 38.1353 3.68005 38.5802L27.4778 47.9179C29.0464 48.5378 30.7836 48.5833 32.3825 48.0463C33.9813 47.5093 35.3389 46.4243 36.2152 44.9832L50.4885 21.6523C50.9942 20.8232 51.3076 19.8913 51.4056 18.9251C51.5037 17.9589 51.3838 16.983 51.0549 16.0692C50.726 15.1555 50.1964 14.3271 49.5051 13.645C48.8138 12.9629 47.9783 12.4445 47.0602 12.1279ZM21.0214 35.5521H18.2602V27.6685H8.53564V35.5521H5.77436V17.0635H8.53564V24.9339H18.2602V17.0635H21.0214V35.5521ZM34.2009 27.295V35.5521H31.533V27.295L23.5293 17.0769H26.9175L32.8136 24.7871L34.8012 22.0525L39.1899 20.7186L34.2009 27.295Z"
            fill="white" />
          <path
            d="M43.8051 13.6217L36.7885 19.9713C36.7518 20.0005 36.7264 20.0417 36.717 20.0877C36.7075 20.1336 36.7145 20.1815 36.7368 20.2228C36.7591 20.2642 36.7952 20.2963 36.8387 20.3138C36.8823 20.3312 36.9307 20.3327 36.9753 20.3181L40.1368 19.411C40.1593 19.4061 40.1804 19.3965 40.1989 19.3826C40.2173 19.3688 40.2325 19.3512 40.2435 19.331L44.1119 13.8884C44.1473 13.8478 44.1651 13.7947 44.1613 13.7409C44.1576 13.6871 44.1326 13.637 44.0919 13.6016C44.0718 13.5841 44.0484 13.5707 44.0231 13.5623C43.9978 13.5538 43.971 13.5504 43.9444 13.5523C43.8906 13.556 43.8405 13.581 43.8051 13.6217Z"
            fill="#6CAD46" />
        </svg>
      </a>
    </ng-template>
  </ion-col>
  <ion-col size="1" class="ion-no-padding">
    <div class="divider"></div>
  </ion-col>
</ion-row>

<!-- MOBILE - MENU ACCORDIONS -->
<ion-row
  class="ion-hide-lg-up footer-row-top ion-align-items-center ion-padding-horizontal">
  <ion-col size="12" class="ion-no-padding">
    <app-accordion
      expandHeight="100px"
      [expanded]="item.expanded"
      *ngFor="let item of menus">
      <div class="accordion-title" (click)="expandItem(item)">
        <ion-icon
          [name]="
            item.expanded ? 'chevron-up-outline' : 'chevron-down-outline'
          "></ion-icon>
        {{ item.title }}
      </div>
      <div class="accordion-content">
        <ion-text *ngFor="let child of item.children">
          <a
            hrefToRouterLink
            [href]="linkToPage(child)"
            [attr.target]="child.newWindow ? '_blank' : '_self'"
            >{{ child.title }}</a
          >
        </ion-text>
      </div>
    </app-accordion>
  </ion-col>
</ion-row>

<!-- SOCIAL LINKS & STATIC PAGES -->
<ion-row
  class="footer-row-middle ion-align-items-center ion-padding-horizontal">
  <ion-col size="auto" class="ion-no-padding">
    <ion-text>
      <a *ngIf="directionsLink" [href]="directionsLink" target="_blank">
        Get Directions
      </a>
    </ion-text>
  </ion-col>
  <ion-col size-lg="auto" class="ion-no-padding ion-text-end">
    <a
      *ngIf="social?.facebookPageURL"
      [href]="social.facebookPageURL"
      target="_blank"
      class="footer-icon"
      ><ion-icon name="logo-facebook"></ion-icon
    ></a>
    <a
      *ngIf="social?.youtubeChannelURL"
      [href]="social.youtubeChannelURL"
      target="_blank"
      class="footer-icon"
      ><ion-icon name="logo-youtube"></ion-icon
    ></a>
    <a
      *ngIf="social?.instagramAccountURL"
      [href]="social.instagramAccountURL"
      target="_blank"
      class="footer-icon"
      ><ion-icon name="logo-instagram" size></ion-icon
    ></a>
    <a
      *ngIf="environment?.tiktok_url"
      [href]="environment?.tiktok_url"
      target="_blank"
      class="footer-icon"
      ><ion-icon name="logo-tiktok" size></ion-icon
    ></a>
    <a
      *ngIf="social?.linkedInProfileURL"
      [href]="social.linkedInProfileURL"
      target="_blank"
      class="footer-icon"
      ><ion-icon name="logo-linkedin"></ion-icon
    ></a>
    <a
      *ngIf="social?.pinterestURL"
      [href]="social.pinterestURL"
      target="_blank"
      class="footer-icon"
      ><ion-icon name="logo-pinterest"></ion-icon
    ></a>
  </ion-col>

  <ion-col size="12" size-lg="8" class="pages ion-no-padding ion-padding-top">
    <ion-text *ngIf="pageTermsAndConditions">
      <a
        hrefToRouterLink
        [href]="'/page/' + pageTermsAndConditions"
        class="link-page"
        >Terms &amp; Conditions</a
      >
    </ion-text>
    <ion-text *ngIf="pageDisclaimer">
      <ng-container *ngIf="pageTermsAndConditions">&nbsp;|&nbsp;</ng-container>
      <a hrefToRouterLink [href]="'/page/' + pageDisclaimer" class="link-page"
        >Disclaimer</a
      >
    </ion-text>
    <ion-text *ngIf="pagePrivacyPolicy">
      &nbsp;|&nbsp;
      <a
        hrefToRouterLink
        [href]="'/page/' + pagePrivacyPolicy"
        class="link-page"
        >Privacy Policy</a
      >
    </ion-text>

    <!-- Sitemap link -->
    <ion-text>
      &nbsp;|&nbsp;
      <a hrefToRouterLink [href]="'/sitemap'" class="link-page">Sitemap</a>
    </ion-text>

    <ion-text class="ion-hide-lg-down">
      <div class="copyright">
        &copy; {{ currentYear }} Hyprop. All Rights Reserved.
      </div>
    </ion-text>
  </ion-col>
</ion-row>

<!-- MOBILE - LOGO STRIP -->
<ion-row class="ion-hide-lg-up footer-row-bottom logo ion-align-items-center">
  <ion-col class="ion-no-padding">
    <div class="divider"></div>
  </ion-col>
  <ion-col size="auto" class="ion-no-padding ion-padding-horizontal">
    <ng-container
      *ngIf="
        environment.environment_name === 'canalwalk' ||
          environment.environment_name === 'glen';
        else singleLogo
      ">
      <a href="https://www.hyprop.co.za/" target="_blank" class="logo-hyprop">
        <img
          src="/assets/logo-hyprop.png"
          srcset="/assets/logo-hyprop@2x.png 2x"
          alt="Hyprop"
          height="53" />
      </a>
      <img
        src="/assets/logo-ellerines.png"
        srcset="/assets/logo-ellerines@2x.png 2x"
        alt="Hyprop"
        class="logo-ellerines"
        height="52" />
    </ng-container>
    <ng-template #singleLogo>
      <a href="https://www.hyprop.co.za/" target="_blank">
        <svg
          width="52"
          height="49"
          viewBox="0 0 52 49"
          fill="none"
          xmlns="http://www.w3.org/2000/svg">
          <path
            d="M47.0602 12.1279L11.8572 0.402452C10.7145 0.0219435 9.49967 -0.0907874 8.3065 0.07297C7.11333 0.236727 5.97377 0.672589 4.97587 1.34688C3.97797 2.02117 3.14844 2.91584 2.55136 3.96178C1.95429 5.00771 1.60565 6.1769 1.53238 7.37903L0.0116766 32.8309C-0.066233 34.0545 0.247247 35.2711 0.906743 36.3047C1.56624 37.3384 2.53754 38.1353 3.68005 38.5802L27.4778 47.9179C29.0464 48.5378 30.7836 48.5833 32.3825 48.0463C33.9813 47.5093 35.3389 46.4243 36.2152 44.9832L50.4885 21.6523C50.9942 20.8232 51.3076 19.8913 51.4056 18.9251C51.5037 17.9589 51.3838 16.983 51.0549 16.0692C50.726 15.1555 50.1964 14.3271 49.5051 13.645C48.8138 12.9629 47.9783 12.4445 47.0602 12.1279ZM21.0214 35.5521H18.2602V27.6685H8.53564V35.5521H5.77436V17.0635H8.53564V24.9339H18.2602V17.0635H21.0214V35.5521ZM34.2009 27.295V35.5521H31.533V27.295L23.5293 17.0769H26.9175L32.8136 24.7871L34.8012 22.0525L39.1899 20.7186L34.2009 27.295Z"
            fill="white" />
          <path
            d="M43.8051 13.6217L36.7885 19.9713C36.7518 20.0005 36.7264 20.0417 36.717 20.0877C36.7075 20.1336 36.7145 20.1815 36.7368 20.2228C36.7591 20.2642 36.7952 20.2963 36.8387 20.3138C36.8823 20.3312 36.9307 20.3327 36.9753 20.3181L40.1368 19.411C40.1593 19.4061 40.1804 19.3965 40.1989 19.3826C40.2173 19.3688 40.2325 19.3512 40.2435 19.331L44.1119 13.8884C44.1473 13.8478 44.1651 13.7947 44.1613 13.7409C44.1576 13.6871 44.1326 13.637 44.0919 13.6016C44.0718 13.5841 44.0484 13.5707 44.0231 13.5623C43.9978 13.5538 43.971 13.5504 43.9444 13.5523C43.8906 13.556 43.8405 13.581 43.8051 13.6217Z"
            fill="#6CAD46" />
        </svg>
      </a>
    </ng-template>
  </ion-col>
  <ion-col class="ion-no-padding">
    <div class="divider"></div>
  </ion-col>
  <ion-col size="12">
    <ion-text>
      <div class="copyright">
        &copy; {{ currentYear }} Hyprop. All Rights Reserved.
      </div>
    </ion-text>
  </ion-col>
</ion-row>
